export enum ChartPeriod {
  Raw = "raw",
  Hourly = "hourly",
  Daily = "daily",
  Monthly = "monthly",
}
